export default __webpack_public_path__ + "static/media/book-header.0aecfaeb.svg";